import { useGenerateReports } from '../../ExcelExportDialog/utils';
import { ExcelExportFormValues } from '../types';

export interface UseExcelExportLogicProps {
  pageType: string | null | undefined;
  firmInfo: any;
  companyInfo: any;
  fundInfo: any;
  currentMeasurementDateId?: number | null;
  formValues: ExcelExportFormValues;
  setErrors: (errors: any) => void;
}

export const useExcelExportLogic = ({
  pageType,
  firmInfo,
  companyInfo,
  fundInfo,
  currentMeasurementDateId,
  formValues,
  setErrors,
}: UseExcelExportLogicProps) => {
  const { generateReport, generateFirmSummaryReport, generateFundSummaryReport, generateFundInvestmentsReport } =
    useGenerateReports({
      pageType,
      firmInfo,
      companyInfo,
      fundInfo,
      currentMeasurementDateId,
      setErrors,
      formValues,
    });

  return {
    generateReport,
    generateFirmSummaryReport,
    generateFundSummaryReport,
    generateFundInvestmentsReport,
  };
};
